
import React from "react";
import { Card } from "@/components/ui/card";
import { CategoriesManager } from "@/components/categories/CategoriesManager";
import { RemixIcon } from "@/components/shared/RemixIcon";

const Products = () => {
  return (
    <div className="space-y-8">
      <Card className="glass-card p-6 animate-fadeIn">
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-semibold mb-4">Products</h2>
            <p className="text-muted-foreground">
              Manage product categories and customization options.
            </p>
          </div>
          <RemixIcon name="bookmark-line" size="2x" className="text-primary" />
        </div>
      </Card>

      <CategoriesManager />
    </div>
  );
};

export default Products;
